import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

export default function PublicLayout() {
    return (
        <>
            <Header />
            <main className="App-main">
                <Outlet />
            </main>
            <Footer />
        </>
    );
}
